import React from 'react';

const SatValidationErrMsg = props => {
  const { visible = false, type = 'info', wide = false, message = '' } = props;

  const getClass = type => {
    let className = 'text-info ico-type';

    if (!wide) className += ' col2';
    if (type === 'info') return className;
    else if (type === 'error') return `${className} error`;
    else if (type === 'check') return `${className} blue`;
  };

  return (
    visible && (
      <p className={getClass(type)}>
        {message.indexOf('\n') > 0
          ? message.split('\n').map((str, index) => (
              <React.Fragment key={index}>
                {str}
                {index < message.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))
          : message}
      </p>
    )
  );
};

export default SatValidationErrMsg;
